import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IrisIconComponent } from '@sondermind/iris/icon';

import { PublicHeaderComponent } from './public-header.component';

@NgModule({
  declarations: [PublicHeaderComponent],
  imports: [
    CommonModule,
    IrisIconComponent
  ],
  exports: [PublicHeaderComponent]
})
export class PublicHeaderModule { }
